import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import './tableau-dashboard-styles.scss'; // Assuming you have some styles for this component
import { ApiEndpoints, Constants } from '../../constants/appConstants';
import httpService from '../../services/httpService';
import { ProjectConfiguration } from '../P4P/ProviderProfile/models';
import { useAppContext } from '../../Context';
import ComingSoon from '../../pages/ComingSoon';
const TableauDashboardComponent: React.FC = () => {
    const [projectConfiguration, setProjectConfiguration] = useState<ProjectConfiguration | null>(null);
    const [tableauCdnJsUrl, setTableauCdnJsUrl] = useState<string>();
    const [dashboardType, setDashboardType] = useState<string>('');
    const [showComingSoon, setShowComingSoon] = useState<boolean>(false);
    const location = useLocation();
    const { providerType } = useAppContext();

    useEffect(() => {
        const portal = location.state?.portal;
        const isP4P = portal === Constants.P4P_TABLEAU_URL_KEY;

        if (isP4P) {
            // P4P: redirect to coming soon if RS provider type
            if (providerType === Constants.RSKey) {
                setShowComingSoon(true);
                return;
            }
            setDashboardType(Constants.P4P_TABLEAU_URL_KEY);    
        } else {
            // PBC: use provider-type-specific URL
            if (providerType === Constants.SCOKey) {
                setDashboardType(Constants.PBC_TABLEAU_URL_KEY);
            } else if (providerType === Constants.RSKey) {
                setDashboardType(Constants.PBC_RS_TABLEAU_URL_KEY);
            } else {
                setDashboardType('');
            }
        }
    }, [location.state?.portal, providerType]);

    useEffect(() => {
        fetchTableauCdnJsUrl();
        if (dashboardType) {
            fetchProjectConfigurationDetails();
        }
    }, [dashboardType]);

    const fetchProjectConfigurationDetails = async () => {
        httpService
            .get(`${ApiEndpoints.GetProjectConfigurationDetailsByKey}/${dashboardType}`)
            .then((response: any) => {
                setProjectConfiguration(response.data);
            })
            .catch((error: any) => {
                console.log("Error: ", error);
            });
    };
    const fetchTableauCdnJsUrl = async () => {
        httpService
            .get(`${ApiEndpoints.GetProjectConfigurationDetailsByKey}/${Constants.TABLEAU_CDN_JS_URL_KEY}`)
            .then((response: any) => {
                setTableauCdnJsUrl(response.data.configValue);
            })
            .catch((error: any) => {
                console.log("Error: ", error);
            });
    };
    return (
        <div className="tableau-dashboard-container">
            {showComingSoon ? (
                <ComingSoon />
            ) : (
                tableauCdnJsUrl && projectConfiguration && projectConfiguration.configValue &&
                (<>
                    <iframe
                        src={`${projectConfiguration.configValue}?:embed=y&:tabs=no&:toolbar=no&:showAppBanner=false&:showShareOptions=true&:display_count=no&:showVizHome=no&:origin=viz_share_link`}
                        title="Executive Dashboard"
                        allowFullScreen
                    />
                    <script type='module' src={tableauCdnJsUrl}></script>
                </>)
            )}
        </div>
    )
};

export default TableauDashboardComponent;